import { css } from 'styled-components';
import token from 'styled-token';
import { StyledAdornment } from '../../components/Adornment/Adornment.styles';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { StyledInput } from '../../components/Input/Input.styles';
import { mediaBreakpointMixin } from '../mediaBreakpointMixin';
import { sizeMixin } from '../sizeMixin';
import { spaceMixin } from '../spaceMixin';
import { typographyMixin } from '../typographyMixin';
var largeCSS = function largeCSS(props) {
  return token('SearchBox.large.paddingLeft', function (paddingLeft) {
    return css(["> ", "{padding-left:", ";}"], StyledInput, paddingLeft ? paddingLeft + "px" : spaceMixin('md')(props));
  })(props);
};
var searchBoxCSS = function searchBoxCSS(large) {
  return function (props) {
    return token({
      borderWidth: 'Input.borderWidth',
      boxShadow: 'SearchBox.boxShadow',
      fontType: 'SearchBox.fontType',
      height: large ? 'SearchBox.heightLarge' : 'SearchBox.height',
      iconColor: 'SearchBox.iconColor',
      iconSize: large ? 'SearchBox.iconSizeLarge' : 'SearchBox.iconSize'
    }, function (_ref) {
      var borderWidth = _ref.borderWidth,
        boxShadow = _ref.boxShadow,
        fontType = _ref.fontType,
        height = _ref.height,
        iconColor = _ref.iconColor,
        iconSize = _ref.iconSize;
      return css(["box-shadow:", ";> ", ",> ", "{", " ", "}", "{color:", ";height:", "px;width:", "px;}", ";"], boxShadow, StyledInput, StyledAdornment, typographyMixin(Object.assign({
        fontType: fontType,
        fontTypeIconAlignment: false
      }, props)), sizeMixin({
        fontType: fontType,
        borderWidth: borderWidth * 2,
        size: height
      })(props), StyledIcon, iconColor, iconSize, iconSize, large ? largeCSS(props) : '');
    })(props);
  };
};

/** @class SearchBoxMixin */
/** @method */
export var SearchBoxMixin = function SearchBoxMixin(props) {
  return [searchBoxCSS(false)(props), css(["@media ", "{", "}"], mediaBreakpointMixin('md')(props), searchBoxCSS(true)(props))];
};